/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempArrowsDownDoubleTop2: {
  name: 'temp-arrows-down-double-top-2';
  data: string;
} = {
  name: 'temp-arrows-down-double-top-2',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H7Zm0 3a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H7Z" fill="currentColor"/></svg>`,
};
